import type { ICatalogo, IRespuestaApiLista } from "../../globales/interfaces";
import api from "../../utils/api";

export class TipoTareaModelo {
    

    constructor() { }
    public async obtenerListaTiposTarea(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/TipoTarea/Listar`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

}

